import { SerializedStyles, css } from "@emotion/react";

import theme from "../../styles/theme";
import { black, greyLight, greySecondary, greyDark } from "../../styles/variables";
import { controllers } from "../ImageUploader/styles";

const { spacing } = theme;

export const select = css`
  border-radius: 4px;
  width: 100%;
  height: 40px;
  color: ${black};
  padding: 6px 0;

  svg {
    color: ${black};
  }

  .MuiSelect-select {
    font-weight: normal;
  }

  .MuiSelect-select:focus {
    background-color: unset;
  }

  &.MuiInput-underline::after {
    display: none;
  }

  &:hover {
    background: ${greySecondary};
  }
`;

export const menu = css`
  .MuiMenu-paper {
    margin-top: 8px;
  }

  .MuiSelect-select {
    font-weight: bold;
  }

  .MuiListItem-root.Mui-selected {
    font-weight: bold;
    background-color: unset;
  }
`;

export const watermarkImgUploader = css`
  margin-top: ${spacing(1)}px;
`;

export const container = (disable?: boolean): SerializedStyles => css`
  position: relative;
  width: 202px;
  height: 202px;
  border-radius: 4px;
  background: ${greyLight};

  &:hover .css-${controllers.name} {
    display: ${!disable && "block"};
  }
`;

export const allowedDomainContent = css`
  margin: ${spacing(1, 0)};
  color: ${greyDark};
`;

export const addIcon = css`
  margin-right: ${spacing(1)}px;
`;

export const btnAddDomain = css`
  font-weight: bold;
`;

export const hidden = css`
  display: none;
`;
